import { h } from "preact";
import { useState } from "preact/hooks";
import { Button, Divider, Form, Input, Select } from "antd";


export default function AddMemberSection(props) {

    const [currentState, setCurrentState] = useState({ username: "", email: "", role: "developer" });

    const onUsernameChange = (usernameRef) => {
        setCurrentState({ ...currentState, username: usernameRef.target.value });
    }

    const onEmailChange = (emailRef) => {
        setCurrentState({ ...currentState, email: emailRef.target.value });
    }

    const onRoleChange = (selectedRole) => {
        setCurrentState({ ...currentState, role: selectedRole });
    }

    const onAddButtonClick = (event) => {
        if (typeof props.onAdd === "function") {
            props.onAdd.call(this, currentState.username, currentState.email, currentState.role);
        }
    }

    const isUsernameFieldEmpty = currentState.username?.length === 0;
    const isEmailFieldEmpty = currentState.email?.length === 0;
    const disabledState = props.disabled || isUsernameFieldEmpty || isEmailFieldEmpty;

    return (
        <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 14 }}
            layout="vertical"
        >
            <Input.Group size="large">
                <Form.Item label={"Username"}>
                    <Input onChange={onUsernameChange} type="text" />
                </Form.Item>
                <Form.Item label={"Email"}>
                    <Input onChange={onEmailChange} type="text" />
                </Form.Item>
                <Form.Item label={"Role"}>
                    <Select
                        defaultValue={"developer"}
                        onChange={onRoleChange}
                    >
                        <Select.Option disabled={true} value={"admin"}>
                            Admin
                        </Select.Option>
                        <Select.Option value={"developer"}>
                            Developer
                        </Select.Option>
                        <Select.Option value={"reporter"}>
                            Reporter
                        </Select.Option>
                    </Select>
                </Form.Item>
                <Divider />
                <Form.Item>
                    <Button
                        onClick={onAddButtonClick}
                        disabled={disabledState}
                        type="primary"
                        size="large"
                    >
                        Add
                    </Button>
                </Form.Item>
            </Input.Group>
        </Form>
    );
}